import {
  AppHeaderNav,
  AppHeaderRoot,
  AppHeaderThemeToggle,
  type BreadcrumbsProps,
} from '@/components/shared/AppHeader';
import { ManagementUserMenu } from '@/components/shared/ManagementUserMenu';
import { UploadTrayButton } from '@/components/shared/UploadTray';
import { useTranslator } from '@/hooks/useTranslator';

/**
 * The header in the management area.
 *
 * What it leaves out is the point. No AI processing queue (the assistant works
 * on the operator's own company data) and no support chat (that is the channel
 * these operators answer rather than use). Notifications are out too: the feed
 * is a customer-app feature about a company's own activity, and an operator
 * here is between identities — anything in it either belongs to the account
 * they just left or to no company at all.
 *
 * Uploads stay, because the tray is about this browser tab's own transfers.
 */
export function ManagementHeader({
  breadcrumb,
  breadcrumbTrail,
}: BreadcrumbsProps) {
  const { getTranslation } = useTranslator({ page: 'appHeader' });

  return (
    <AppHeaderRoot
      left={
        <AppHeaderNav
          breadcrumb={breadcrumb}
          breadcrumbTrail={breadcrumbTrail}
        />
      }
      right={
        <>
          <UploadTrayButton tooltip={getTranslation('uploads')} />

          <AppHeaderThemeToggle />

          <div className='w-px h-4.5 bg-border mx-1' />

          <ManagementUserMenu />
        </>
      }
    />
  );
}
